import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventEmitterService } from 'app/service/event-emitter-service';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';

@Component({
  selector: 'app-relatorio-pendente-recuperacao',
  templateUrl: './relatorio-pendente-recuperacao.component.html',
  styleUrls: ['./relatorio-pendente-recuperacao.component.scss']
})
export class RelatorioPendenteRecuperacaoComponent implements OnInit, OnDestroy {
  result ;
  resultEmRecuperacao;
  loading = false;
  pendenteRecuperacao = [];
  emRecuperacao = [];
  rgInput ;
  logIsvisivel = false;
  logs = [];
  dateTime;
  constructor(private service : SolicitacaoService) {
    EventEmitterService.get("isPrintPage").emit(true);
  }

  ngOnInit() {
    this.carregarPendenteRecuperacao();
    let date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
  }
  
  ngOnDestroy(): void {
    EventEmitterService.get("isPrintPage").emit(false);
  }

  carregarPendenteRecuperacao(){
    this.loading = true;
    this.service.listarCaixasPendeteRecuperacao().subscribe(data=>{
      this.result = data;
      console.log(this.result)
      if(this.result.cod == 200){
        this.pendenteRecuperacao = this.result.result;
        this.loading = false;
      }
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/recuperar-caixas/relatorio-pendente-recuperacao/relatorio-pendente-recuperacao.component.ts